import type {
  AlloyLegacyThemeDesignTokens,
  SearchFieldDesignTokens,
} from '../types';
import type { Weave3SearchInput } from '../types/weave3Types';
import { WeaveTheme } from '../types/weaveTypes';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getSearchFieldTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): SearchFieldDesignTokens => ({
  icon: {
    color: theme.tokens.colors.icon.tertiary.value,
  },
  clearButton: {
    icon: {
      fill: theme.tokens.colors.icon.secondary.value,
    },
  },
  rightAdornment: {
    gap: `${theme.spacing.XS}px`,
  },
});

/**
 * Weave 2 has no search component, so both icons take the generic medium
 * icon colour.
 */
export const getSearchFieldTokensWeave = (
  tokens: WeaveTokens,
): SearchFieldDesignTokens => ({
  icon: {
    color: tokens?.semantic?.['icon-color']?.medium,
  },
  clearButton: {
    icon: {
      fill: tokens?.semantic?.['icon-color']?.medium,
    },
  },
  rightAdornment: {
    gap: tokens?.generic?.spacing?.xs,
  },
});

/** W3 has a search node, so the two icons resolve separately. Clear `hover`/`pressed` have no slot. */
export const getSearchFieldTokensWeave3 = (
  search?: Weave3SearchInput,
): SearchFieldDesignTokens => ({
  icon: {
    color: search?.icon?.fill,
  },
  clearButton: {
    icon: {
      fill: search?.['clear-icon']?.fill?.default,
    },
  },
  rightAdornment: {
    gap: search?.progressring?.gap,
  },
});
